module.exports = __webpack_public_path__ + "img/firend.8b3a0b93.png";